module.exports = __webpack_public_path__ + "img/other_22.2178378a.png";